<agpr-take-over-panel
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [showFooter]="false"
    (visibleChange)="close()"
    [responsiveWidth]="true"
    [minPanelWidth]="minPanelWidth"
    [maxPanelWidth]="maxPanelWidth"
    [noScroll]="true"
    [noPadding]="true"
>
    <ng-template #noScrollContent>
        <div class="agpr-aiHelper">
            <div class="agpr-aiHelper-header">
                <div class="agpr-aiHelper-headerLeft">
                    <span class="agpr-aiHelper-headerIcon fa-kit-duotone fa-agpr-ai-generic" aria-hidden="true"></span>
                    <h2>{{ 'Discover.distribution.newAiDistribution.aiDistributionDialog.header' | localize }}</h2>
                </div>
                <div class="agpr-aiHelper-headerRight">
                    <span class="agpr-aiHelper-headerRight-asterisk">*</span>
                    <span>{{ 'Common.dialog.aiHelper.requiredFields' | localize }}</span>
                </div>
            </div>
            <div class="agpr-aiHelper-bodyWrapper">
                <div class="agpr-aiHelper-bodyForm">
                    <agpr-scroll-panel class="agpr-aiHelper-bodyFormScroll">
                        <div class="agpr-aiHelper-bodyFormScroll-container">
                            <div class="agpr-aiHelper-bodyFormScroll-headerContainer">
                                <span class="agpr-aiHelper-bodyFormScroll-header">{{ 'Common.dialog.aiHelper.title' | localize}}</span>
                                <span class="agpr-aiHelper-bodyFormScroll-templateType">
                                    {{'Discover.distribution.newAiDistribution.template' | localize }}{{ 'Discover.distribution.newAiDistribution.template.' + templateType | localize}}
                                </span>
                            </div>
                            <agpr-ai-setting-form
                                [headingLevel]="3"
                                [allowCustomOptions]="true"
                                [showTargetAudienceField]="true"
                                [showPurposeField]="true"
                                [(ngModel)]="aiSettings"
                                (ngModelChange)="validateAiSettings()"
                                (aiQuickTip)="showQuickTip($event)"
                            ></agpr-ai-setting-form>
                        </div>
                    </agpr-scroll-panel>
                    <agpr-action-bar>
                        <ng-template #left>
                            <agpr-button
                                label="Core.button.cancel"
                                (click)="close();"
                                [style]="buttonEnum.secondary"
                            >
                            </agpr-button>
                        </ng-template>
                        <ng-template #right>
                            <agpr-button
                                [id]="'distribution_create_draft'"
                                [disabled]="!canGenerate || !doneStreaming"
                                [label]="hasGenerated ? 'Common.dialog.aiHelper.regenerateButton' : 'Common.dialog.aiHelper.createDraft'"
                                [style]="hasGenerated ? buttonEnum.primaryB : buttonEnum.primary"
                                (click)="generate()"
                            >
                            </agpr-button>
                        </ng-template>
                    </agpr-action-bar>
                </div>
                <div class="agpr-aiHelper-bodyContent">
                    <div class="agpr-aiHelper-bodyContentGroup">
                        @if (showGeneratedContent) {
                            <div class="agpr-aiHelper-generatedContent-headerContainer">
                                <span class="agpr-aiHelper-generatedContent-header-icon fa-kit-duotone fa-agpr-ai"></span>
                                <span class="agpr-aiHelper-generatedContent-header">
                                    {{ 'Common.dialog.aiHelper.generatedContent.header' | localize }}
                                </span>

                            </div>
                        } @else {
                            <div class="agpr-aiHelper-bodyContentGroup-container">
                                <agpr-scroll-panel [agprLoading]="loading">
                                    <div
                                        #quickTipContainer
                                        id="open-ai-quickTip-container"
                                        class="agpr-aiHelper-quickTip-container"
                                    >
                                        <div class="agpr-aiHelper-quickTip-header">
                                            <span
                                                class="agpr-aiHelper-quickTip-header-icon agpr-i-light-bulb"
                                                aria-hidden="true"
                                            ></span>
                                            <h2> {{ 'Common.dialog.aiHelper.quickTip.header' | localize }}</h2>
                                            <div class="agpr-aiHelper-quickTip-title">
                                                {{ quickTipInfo.header | localize }}
                                            </div>
                                        </div>
                                        <ul
                                            *ngIf="quickTipInfo.hints.length"
                                        >
                                            <li
                                                *ngFor="let quickTip of quickTipInfo.hints"
                                            >{{ quickTip | localize }}</li>
                                        </ul>
                                    </div>
                                </agpr-scroll-panel>
                            </div>
                        }
                        <agpr-scroll-panel [agprLoading]="loading">
                            <div class="agpr-aiHelper-bodyContentGenerated">
                                <ng-container
                                    *ngFor="let element of contentElements"
                                >
                                    <agpr-ai-generated-content-card
                                        [contentElement]="element"
                                        [disabled]="!doneStreaming || failedGenerateBody"
                                        (regenerateClicked)="regenerateSingleElement($event)"
                                    >
                                    </agpr-ai-generated-content-card>
                                </ng-container>
                            </div>
                        </agpr-scroll-panel>

                    </div>
                    <div
                        *ngIf="hasGenerated"
                        class="agpr-aiHelper-disclaimerContainer"
                    >
                        <agpr-ai-disclaimer
                            [disabled]="loading || !doneStreaming"
                            (apply)="apply()"
                        >
                        </agpr-ai-disclaimer>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

</agpr-take-over-panel>
